<template>

  <!-- Header Box with important information -->
  <div :class="sticky ? 'sticky-box' : ''"
       class="contactBoxes">

    <div v-for="(box, index) in boxes"
         :key="'contact-'+index"
         class="contactBox round-corners">

      <h2 class="primary--text"
          align="center"> {{ box.title }}</h2>

      <v-divider class="bg-dimmeddark mb-4" />

      <div v-if="box.phone"
           class="contact-line contact-text">
        <a :href="'tel:' + box.phoneClickable">
          <!--  <v-icon>phone</v-icon> --->
          <span class="contact-text"><img src="../../assets/svg/ic_telefon.svg"
                                          height="22px"
                                          style="margin: 0 4px 0 -32px; vertical-align: middle;"> {{ box.phone }}</span>
          <div class="hint">
            {{ box.type==='DMB RECHT' ? box.subtitle : `${box.type}-${box.type === 'Schaden' ? "Auskunft" : "Hotline"}` }}
            <div v-if="box.time">{{ box.time }}
            </div>
          </div>
        </a>
      </div>

      <div v-if="box.email"
           class="contact-line">
        <!-- <v-icon>email</v-icon> -->

        <span class="contact-text">
          <a :href="`mailto:${box.email}`">
            <img src="../../assets/svg/ic_mail.svg"
                 height="22px"
                 style="margin: 0 4px 0 -32px; vertical-align: middle;">
          {{ box.email }}
          </a>
        </span>
        <div class="hint">{{ box.type }}-Mail</div>
      </div>

      <div v-if="box.fax"
           class="contact-line">
        <img src="../../assets/svg/ic_fax.svg"
             height="22px"
             style="margin: 0 8px 0 -32px; vertical-align: middle;">
        <span class="contact-text">{{ box.fax }}</span>
        <div class="hint">{{ box.type }}-Fax</div>
      </div>

      <div v-if="box.type === 'link'">
        <div v-for="(link, subindex) in box.links"
             :key="'link-'+subindex"
             class="contact-line link">
          <v-icon>open_in_new</v-icon>
          <a :href="link.link"
             target="_blank">{{ link.title }}</a>
          <div class="hint">{{ link.subtitle }}</div>
        </div>
      </div>

      <div v-if="box.footnote"
           class="contact-line contact-text">
        <div class="hint">*{{ box.footnote }}
        </div>
      </div>

    </div>

  </div>

</template>
<script>
export default {
  name: "MaklerContactBox",
  props: {
    boxes: {
      type: Array,
      required: true
    },
    sticky: {
      type: Boolean,
      default: false
    }
  }
};
</script>
<style>
.contactBoxes {
  margin-top: 56px;
}

.sticky-box.contactBoxes {
  top: 193px;
  position: -webkit-sticky;
  position: sticky;
}

.scroll-down .sticky-box.contactBoxes {
  -webkit-animation: appear-navbar;
  animation: appear-navbar;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-duration: 0.5s;
  animation-duration: 0.5s;
  -moz-animation-timing-function: ease-out;
}

.scroll-down .sticky-box.contactBoxes {
  -webkit-animation: disappear-navbar;
  animation: disappear-navbar;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-duration: 0.5s;
  animation-duration: 0.5s;
  -moz-animation-timing-function: ease-out;
}

.contactBox {
  background-color: #ebebeb !important;
  width: 312px;
  min-width: 312px;
  padding: 8px;
  margin: 0 auto;
}

.contactBox h2 {
  font-size: 20px !important;
  font-weight: 400;
  color: #0085CF !important;
}

.contactBox .contact-line {
  position: relative;
  padding-left: 32px;
}

.contactBox .contact-line i {
  position: absolute;
  top: 2px;
  left: 0;
  font-size: 20px;
}

.contactBox .contact-line.link i {
  top: 1px;
}

.contactBox .contact-line.link a {
  font-size: 14px;
}

.contactBox .hint {
  font-size: 14px;
  padding-left: 8px;
  color: #808080;
  margin-bottom: 4px;
}

.contactBox .contact-text {
  font-size: 12pt;
  white-space: nowrap;
  position: relative;
}

.contactBox + .contactBox {
  margin-top: 24px;
}

.contactBox .contact-text a {
  color: rgba(0, 0, 0, .87) !important;
}
</style>

